<template>
    <section>
        <Header title="Profiel" show-back-button></Header>
        <v-container>
            <v-form ref="form" @submit.prevent="submit" class="my-4 account-form">
                <v-text-field
                    disabled
                    rounded
                    hide-details="auto"
                    outlined
                    label="E-mailadres"
                    :value="user.email"
                    class="mb-4">
                </v-text-field>
                <v-text-field
                    required
                    rounded
                    hide-details="auto"
                    outlined
                    label="Voornaam"
                    v-model="firstName"
                    class="mb-4">
                </v-text-field>
                <v-text-field
                    rounded
                    hide-details="auto"
                    outlined
                    label="Achternaam"
                    v-model="lastName"
                    class="mb-4">
                </v-text-field>
                <v-text-field
                    rounded
                    hide-details="auto"
                    outlined
                    label="Bestuur"
                    persistent-placeholder
                    v-model="schoolGroup"
                    class="mb-4">
                </v-text-field>
                <v-text-field
                    required
                    rounded
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    label="School"
                    v-model="school"
                    class="mb-4">
                </v-text-field>
                <v-text-field
                    rounded
                    hide-details="auto"
                    outlined
                    label="Functie"
                    persistent-placeholder
                    v-model="schoolFunction"
                    class="mb-4">
                </v-text-field>
                <v-text-field
                    type="password"
                    outlined
                    rounded
                    hide-details="auto"
                    v-model="currentPassword"
                    label="Huidige wachtwoord"
                    :rules="currentPassword || firstPassword || secondPassword  ? currentPasswordRules : []"
                    class="mb-4"
                ></v-text-field>
                <v-text-field
                    type="password"
                    outlined
                    rounded
                    hide-details="auto"
                    v-model="firstPassword"
                    label="Nieuw wachtwoord"
                    :rules="firstPassword ? firstPasswordRules : []"
                    class="mb-4"
                ></v-text-field>
                <v-text-field
                    type="password"
                    outlined
                    rounded
                    hide-details="auto"
                    v-model="secondPassword"
                    label="Herhaal nieuw wachtwoord"
                    :rules="secondPassword || firstPassword ? secondPasswordRules : []"
                    class="mb-6"
                ></v-text-field>
                <v-btn type="submit" color="primary" rounded block class="mb-3 elevation-0">Opslaan</v-btn>
                <v-btn @click="$store.dispatch('logout')" rounded block outlined color="primary" class="mb-3">Uitloggen</v-btn>
                <SchoolSignOutDialog class="elevation-0" @deactivateAccount="deactivateAccount"></SchoolSignOutDialog>
            </v-form>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import {mapState} from "vuex";
import SchoolSignOutDialog from "@/components/profile/SchoolSignOutDialog.vue";
import apiClient from "@/api/apiClient";

export default {
    name: 'Account',
    components: {
        SchoolSignOutDialog,
        Header,
    },
    data: () => ({
        firstName: '',
        lastName: '',
        schoolGroup: '',
        school: '',
        schoolFunction: '',
        currentPassword: '',
        firstPassword: '',
        secondPassword: '',
        submitting: false,
        showErrors: false,
    }),
    mounted() {
        this.firstName = this.user.firstName;
        this.lastName = this.user.lastName;
        this.schoolGroup = this.user.schoolGroup;
        this.school = this.user.school;
        this.schoolFunction = this.user.function;
    },
    computed: {
        currentPasswordRules () {
            return [
                v => (!this.showErrors || !!v) || 'Huidige wachtwoord is verplicht',
            ];
        },
        firstPasswordRules () {
            return [
                v => (!this.showErrors || !!v) || 'Wachtwoord is verplicht',
                v => (!this.showErrors || !v || v.length >= 6) || 'Minimaal 6 karakters',
            ];
        },
        secondPasswordRules () {
            return [
                v => (!this.showErrors || !!v) || 'Wachtwoord is verplicht',
                v => (!this.showErrors || v === this.firstPassword) || 'Wachtwoorden komen niet overeen',
                v => (!this.showErrors || !v || v.length >= 6) || 'Minimaal 6 karakters',
            ];
        },
        ...mapState({
            user: state => state.auth.user,
        }),
    },
    methods: {
        submit () {
            this.showErrors = true;

            // Check if form is valid
            if (!this.$refs.form.validate() || this.submitting) {
                return;
            }

            this.submitting = true;

            this.$store.dispatch('updateUser', {
                firstName: this.firstName,
                lastName: this.lastName,
                schoolGroup: this.schoolGroup,
                school: this.school,
                schoolFunction: this.schoolFunction,
                currentPassword: this.currentPassword,
                newPassword: this.firstPassword,
            }).then(() => {
                // this.$store.dispatch('showSnackbar', { color: 'success', text: 'Wachtwoord opnieuw ingesteld'});
                this.$store.dispatch('showSnackbar', { color: 'success', text: 'Gegevens succesvol gewijzigd.'});

                if (this.currentPassword && this.firstPassword) {
                    return this.$store.dispatch('logout');
                }

                return this.$store.dispatch('getUser');
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Het huidige wachtwoord is ongeldig' });
            }).finally(() => {
                this.submitting = false;
            });
        },
        deactivateAccount () {
            // Archive profile
            apiClient.post('/school-registreren/'+this.user.id+'/afmelden').then(() => {
                // Success, logout
                return this.$store.dispatch('logout');
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Het is niet gelukt om u af te melden.' });
            });
        },
    }
}
</script>
